import React, {useState, useRef, useEffect} from 'react';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import * as Yup from 'yup';
import { ProgressBar } from 'primereact/progressbar';
import http from '../../../services/http';




export default function FormCreateActionPlanStatus(props) {
    
    const toast = useRef(null);
    const [obj, setObj] = useState('')
    const [, setActionPlan] = useState('')
    const [loading, setLoading] = useState(false)
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        if(props.obj) {
            setObj(props.obj)
        }
        if(props.actionPlan) {
            setActionPlan(props.actionPlan)
        }
    }, [props])
    
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            description: obj?.description || '',
            status: obj?.status || 'FA',
            start_date: obj?.start_date || '',
            end_date: obj?.end_date || '',
        },
        validationSchema: Yup.object({
            description: Yup.string().required("Favor preencher este campo"),
            status: Yup.string().required("Favor preencher este campo"),
            start_date: Yup.string().required("Favor preencher este campo"),
            end_date: Yup.string().required("Favor preencher este campo"),
        }),
        onSubmit: values => {

            let data = {
                description: values.description,
                status: values.status,
                start_date: values.start_date,
                end_date: values.end_date
            }

            submitStatus(data)

            
        },
    });

    function submitStatus(data) {

        const sendFiles = document.getElementById('evidence').files

        setLoading(true);

        const formData = new FormData();

        for (var i=0; i < sendFiles.length; i++) {
            formData.append("files", sendFiles[i]);
        }
        formData.append("company_id", localStorage.getItem("companyId"));
        formData.append("action_plan_id", props.actionPlan.id);
        formData.append("description", data.description);
        formData.append("status", data.status);
        formData.append("start_date", data.start_date);
        formData.append("end_date", data.end_date);

        const sendFile = document.getElementById('evidence').files[0]
        if (sendFile) {
            formData.append("file", sendFile);
        }

        http.post("performance/action-plan/status/create/", formData, {
            onUploadProgress: (progressEvent) => {
                const progress_ = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                )
                setProgress(progress_);
            }
        }).then(() => {
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Status atualizado com sucesso', life: 4000 });
            formik.resetForm()
        })
        .catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 });

        }).finally(() => {
            if (loading) {
                setLoading(false)
            }
            props.getObject()
            setTimeout(() => {
                props.hideOffCanvas()
            }, 2000)
        })
 
    }

    return (
        <form onSubmit={formik.handleSubmit} encType="multipart/form-data">

            <Toast ref={toast} position="top-right" />

            <div className="my-3">
                <label className="form-label fw-bold">Fale sobre o que você fez? <span className="text-danger">*</span></label>
                <textarea className='form-control' name='description' rows={3} required {...formik.getFieldProps('description')} />
                {formik.errors.description ? (<span name="description_error" className="text-vermelho">{formik.errors.description}</span>) : null}
            </div>

            <div className="col mb-4">
                <label className="form-label fw-bold">Status <span className="text-danger">*</span></label>
                <select className='form-select mb-3' {...formik.getFieldProps('status')} required="required">
                    <option value='FA'>1-25%</option>
                    <option value='FB'>25-50%</option>
                    <option value='FC'>50-75%</option>
                    <option value='FD'>75-99%</option>
                    <option value='CS'>Completado</option>
                </select>
            </div>

            <div className='row mb-4 px-0'>
                <div className='col'>
                    <label className="form-label fw-bold">Data de Início <span className="text-danger">*</span></label>
                    <input className="form-control" name='start_date' type="date" required="required" autoComplete="off" {...formik.getFieldProps('start_date')} />
                    {formik.errors.start_date ? (<span name="start_date" className="text-vermelho">{formik.errors.start_date}</span>) : null}
                </div>

                <div className='col'>
                    <label className="form-label fw-bold">Data de Término <span className="text-danger">*</span></label>
                    <input className="form-control" name='end_date' type="date" required="required" autoComplete="off" {...formik.getFieldProps('end_date')} />
                    {formik.errors.end_date ? (<span name="end_date" className="text-vermelho">{formik.errors.end_date}</span>) : null}
                </div>
            </div>

            <div className='my-3'>
                <label className="form-label fw-bold">Evidência</label>
                <input type="file" id='evidence' name='file' className="form-control" accept=".pdf, .doc, .docx, .png, .jpeg" />
            </div>

            {
                progress > 0 && loading ?
                <div className='my-3'>
                <ProgressBar value={progress}></ProgressBar>
                </div>
                : null
            }
            
            <div className="d-grid mx-auto btnMargin">
                <button className="btn btn-success btn-sm btn-rounded" type="submit">
                {
                    obj && obj.id ?
                    <>Atualizar</>
                    :
                    <>Adicionar</>
                }
                </button>
            </div>

            
        </form>
    )
}